import Card from "@/components/Screening/Cards/Card";
import {
  CardsData,
  IEDatum,
  ConsentDatum,
  IndicationEventDatum,
} from "./cards.types";
import { getCards } from "./utilsScreeningCards";
import { getFullRecordConfig } from "./utilsFullRecordTable";
import { useScopeParams } from "@/hooks/useScopeParams";
import { trials } from "../../../utils/trials";

interface ScreeningCardsProps {
  cardsData: CardsData;
  ieData: IEDatum[];
  consentData: ConsentDatum[];
  indicationEventData: IndicationEventDatum[];
}

const ScreeningCards = ({
  cardsData,
  ieData,
  consentData,
  indicationEventData,
}: ScreeningCardsProps) => {
  const { id } = useScopeParams();

  const cards = getCards(cardsData);

  //TODO: Remove this when we set up a config to control fields shown in this card
  const isAcadiaTrial =
    id === trials.acadia["ACP-211-002"] ||
    id === trials.acadia["ACP-204-012"] ||
    id === trials.acadia["ACP-204-013"];

  return (
    <div className="flex flex-col gap-4 w-full">
      {cards.map((card) => {
        // TODO: Remove this per trial conditionals after adding configs served by an API.
        if (
          (trials.bridgebio.PROPEL === id || isAcadiaTrial) &&
          card.key === "indication"
        ) {
          return null;
        }
        const fullRecord = getFullRecordConfig(card.key, {
          cardsData,
          ieData,
          consentData,
          indicationEventData,
        });

        const hasTableValues = fullRecord.dataSource.some((row) =>
          fullRecord.columns.some((col) => row[col.dataIndex] != null),
        );
        if (card.key !== "screening" && !hasTableValues) {
          return null;
        }

        return (
          <div key={card.key} className="bg-white rounded-sm shadow-sm">
            <Card card={card} trialId={id} fullRecord={fullRecord} />
          </div>
        );
      })}
    </div>
  );
};

export default ScreeningCards;
